export const i18nContentHash = 'a40fb3b'
